import React from "react";
import Types from "prop-types";
import LanguageSelector from "../../LanguageSelector";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import PhoneNumber from "../../common/PhoneNumber";
import AppleButton from "../../common/AppleButton";
import FacebookButton from "../../common/FacebookButton";

export class PhoneLoginForm extends React.Component {
  render() {
    const { t, error, submitting, visibleFields } = this.props;
    return (
      <form onSubmit={this.props.onSubmit}>
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>
        <LanguageSelector />
        <h1>{t("login:title")}</h1>
        <h3 />
        {error && <div className="invalid show">{error}</div>}
        <div className="material-form-field">
          <PhoneNumber onPhoneChange={this.props.onPhoneChange} />
        </div>
        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="verify-recover-btn"
          disabled={submitting}
        />

        <div
          id="alternative-login"
          style={{
            display:
              visibleFields.appleButton || visibleFields.facebookButton
                ? "block"
                : "none",
          }}
        >
          <div id="or">{t("common:or")}</div>
          <div className="fb-hint center">{this.getSocialLoginHint()}</div>

          {visibleFields.appleButton && (
            <AppleButton onChange={this.props.onAppleTokenChanged} />
          )}

          {visibleFields.facebookButton && (
            <FacebookButton onChange={this.props.onFacebookTokenChanged} />
          )}
        </div>
        <ReCaptcha />
      </form>
    );
  }

  getSocialLoginHint() {
    const { visibleFields, t } = this.props;
    if (visibleFields.appleButton && visibleFields.facebookButton) {
      return t("login:already_signed_up_apple_or_facebook");
    } else if (!visibleFields.appleButton && visibleFields.facebookButton) {
      return t("login:already_signed_up_facebook");
    } else if (visibleFields.appleButton && !visibleFields.facebookButton) {
      return t("login:already_signed_up_apple");
    }
  }
}

PhoneLoginForm.propTypes = {
  t: Types.func.isRequired,
  state: Types.object.isRequired,
  onPhoneChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
};
export default withTranslation()(PhoneLoginForm);
